export default __webpack_public_path__ + "static/media/rcb_logo.5af7a180.svg";